package com.siriusxm.pia.components

import androidx.compose.runtime.Composable
import com.siriusxm.pia.SXMUI
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

object MessageBoxStyles : StyleSheet() {
    val messageBox by style {
        border(1.px, LineStyle.Solid, SXMUI.messageInfoBorder.value())
        borderRadius(SXMUI.boxRadius.value())
        padding(1.cssRem)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap((1.0).cssRem)

        self + self style {
            marginTop((1.0).cssRem)
        }
    }

    val icon by style {

    }

    val info by style {
        backgroundColor(SXMUI.messageInfoBackground.value())
        property("border-color", SXMUI.messageInfoBorder.value())

        child(self, className(icon)) style {
            color(SXMUI.messageInfoBorder.value())
        }

    }
    val warn by style {
        backgroundColor(SXMUI.messageWarnBackground.value())
        property("border-color", SXMUI.messageWarnBorder.value())
    }
    val alert by style {
        backgroundColor(SXMUI.messageAlertBackground.value())
        property("border-color", SXMUI.messageAlertBorder.value())

        child(self, className(icon)) style {
            color(SXMUI.messageAlertForeground.value())
        }
    }

    val success by style {
        backgroundColor(SXMUI.messageSuccessBackground.value())
        property("border-color", SXMUI.messageSuccessBorder.value())

        child(self, className(icon)) style {
            color(SXMUI.messageSuccessForeground.value())
        }

        color(SXMUI.messageSuccessForeground.value())
    }

}


enum class MessageType(val className: String, val icon: String) {
    INFO(MessageBoxStyles.info, "help_outline"),
    WARNING(MessageBoxStyles.warn, "warning"),
    ALERT(MessageBoxStyles.alert, "error"),
    SUCCESS(MessageBoxStyles.success, "check_circle")
}

@Composable
fun messageBox(message: String, type: MessageType = MessageType.INFO) {
    messageBox(type) {
        Text(message)
    }
}

@Composable
fun messageBox(type: MessageType = MessageType.INFO, content: @Composable () -> Unit) {
    Div({
        classes(MessageBoxStyles.messageBox)
        classes(type.className)
    }) {
        Div({ classes(MessageBoxStyles.icon) }) {
            icon(type.icon)
        }
        Div {
            content()
        }
    }
}
